module.exports = ['$translate', $translate => (object, key, translation) => {
  if (object && object[key]) {
    return moment(object[key]).format($translate.instant(translation));
  }
  return null;
}];



// WEBPACK FOOTER //
// ./main/filters/display-date-filter.js